import { palette } from '.';
import { hexToRgb } from '../utils';
export const shadows = {
  main30: `0 1px 16px 0 rgba(${hexToRgb(palette.solidBlack)}, 0.22), 0 0 1px 0 rgba(${hexToRgb(palette.solidBlack)}, 0.32)`,
  light30: `0px 1px 2px rgba(${hexToRgb(palette.solidBlack)}, 0.22), 0px 0px 1px rgba(${hexToRgb(palette.solidBlack)}, 0.32)`,
  datePickerDayPicker30: `0 0 1px rgba(${hexToRgb(palette.solidBlack)}, 0.32), 0 1px 16px rgba(${hexToRgb(palette.solidBlack)}, 0.22)`,
  datePickerDayPicker40: `4px 4px 0 0 rgba(${hexToRgb(palette.solidBlack)}, 0.08)`,
  shadow40: `4px 4px 0 0 rgba(${hexToRgb(palette.solidBlack)}, 0.08)`,
  topShadow40: `-4px -4px 0 0 rgba(${hexToRgb(palette.solidBlack)}, 0.08)`
};